import React, { useContext, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { posthog } from 'posthog-js';
import { useSelector } from 'react-redux';
import styles from './PageLayout.module.css';
import { UserSessionContext } from '@common/context/UserSessionContext/UserSessionContext';
import { selectColorScheme } from '../interface/interfaceSlice';

const PageLayout = () => {
	const prefStatusRef = useRef<"NotLoggedIn" | "LoggedIn">('NotLoggedIn');
	const session = useContext(UserSessionContext);
	const colorScheme = useSelector(selectColorScheme);

	// Make sure widgets are hidden if not logged in.
	useEffect(() => {

		// Using try as a workaround for:
		// https://github.com/PostHog/posthog-js/issues/323
		if(prefStatusRef.current !== session.state){
			prefStatusRef.current = session.state;
			try {
				// Reset user info in case multiple users share the same computer.
				console.log('Posthog reset');
				posthog.reset(true);
			} catch (e) {
				console.warn('Failed to reset posthog');
			}
		}
	}, [session.state]);

  // console.log('PageLayout');
  return (
    <div className={styles.Container} data-theme={colorScheme}>
			<div className={styles.Section}>
        <Outlet />
      </div>
    </div>
  );
};

export default PageLayout;
